/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Describe_Your_Listing_Be_SpecInputs */

const en_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your listing. Be specific, include key details, dimensions, condition, etc.`)
};

const es_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe tu anuncio. Sé específico, incluye detalles clave, dimensiones, estado, etc.`)
};

const fr_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décrivez votre annonce. Soyez précis, incluez des détails clés, dimensions, état, etc.`)
};

const de_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibe dein Inserat. Sei spezifisch, füge wichtige Details, Abmessungen, Zustand usw. hinzu.`)
};

const ja_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品内容を説明してください。主要な詳細、寸法、状態など、具体的に記述してください。`)
};

const zh_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述您的商品。请尽量具体，包含关键细节、尺寸、状况等。`)
};

const ar_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صف إعلانك. كن دقيقاً، قم بتضمين التفاصيل الرئيسية والأبعاد والحالة وما إلى ذلك.`)
};

const id_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deskripsikan listing Anda. Buat agar spesifik, sertakan detail penting, dimensi, kondisi, dll.`)
};

const it_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrivi il tuo annuncio. Sii specifico, includi i dettagli chiave, le dimensioni, lo stato, ecc.`)
};

const ru_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опишите ваше объявление. Будьте точны, укажите ключевые детали, размеры, состояние и т.д.`)
};

const pt_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descreva o seu anúncio. Seja específico, inclua detalhes importantes, dimensões, condição, etc.`)
};

const ko_describe_your_listing_be_spec = /** @type {(inputs: Describe_Your_Listing_Be_SpecInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상품을 설명해 주세요. 주요 세부 정보, 크기, 상태 등을 구체적으로 입력하세요.`)
};

/**
* | output |
* | --- |
* | "Describe your listing. Be specific, include key details, dimensions, condition, etc." |
*
* @param {Describe_Your_Listing_Be_SpecInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const describe_your_listing_be_spec = /** @type {((inputs?: Describe_Your_Listing_Be_SpecInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Describe_Your_Listing_Be_SpecInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_describe_your_listing_be_spec(inputs)
	if (locale === "es") return es_describe_your_listing_be_spec(inputs)
	if (locale === "fr") return fr_describe_your_listing_be_spec(inputs)
	if (locale === "de") return de_describe_your_listing_be_spec(inputs)
	if (locale === "ja") return ja_describe_your_listing_be_spec(inputs)
	if (locale === "zh") return zh_describe_your_listing_be_spec(inputs)
	if (locale === "ar") return ar_describe_your_listing_be_spec(inputs)
	if (locale === "id") return id_describe_your_listing_be_spec(inputs)
	if (locale === "it") return it_describe_your_listing_be_spec(inputs)
	if (locale === "ru") return ru_describe_your_listing_be_spec(inputs)
	if (locale === "pt") return pt_describe_your_listing_be_spec(inputs)
	return ko_describe_your_listing_be_spec(inputs)
});